var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.75C35.0625 3.75 44.25 12.8438 44.25 24C44.25 35.25 35.1562 44.25 24 44.25C12.75 44.25 3.75 35.25 3.75 24C3.75 12.8438 12.75 3.75 24 3.75ZM24 0.75C11.1562 0.75 0.75 11.25 0.75 24C0.75 36.8438 11.1562 47.25 24 47.25C36.75 47.25 47.25 36.8438 47.25 24C47.25 11.25 36.75 0.75 24 0.75ZM20.625 33C19.9688 33 19.5 33.5625 19.5 34.125V34.875C19.5 35.5312 19.9688 36 20.625 36H27.375C27.9375 36 28.5 35.5312 28.5 34.875V34.125C28.5 33.5625 27.9375 33 27.375 33H26.25V19.875C26.25 19.3125 25.6875 18.75 25.125 18.75H20.625C19.9688 18.75 19.5 19.3125 19.5 19.875V20.625C19.5 21.2812 19.9688 21.75 20.625 21.75H21.75V33H20.625ZM24 10.5C22.3125 10.5 21 11.9062 21 13.5C21 15.1875 22.3125 16.5 24 16.5C25.5938 16.5 27 15.1875 27 13.5C27 11.9062 25.5938 10.5 24 10.5Z",
    fill: "#199690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic-info.43e8d4488b0a7a4abeef2bdb20d8c1c9.svg";
export { ForwardRef as ReactComponent };